import {applyTransaction} from "@datorama/akita"
import API from "api/API"
import {ApiSystemLayoutResult} from "app/Interface/Api/System/ApiSystemLayout"
import Logger from "logger/logger"
import {useEffect, useState} from "react"
import {Subscription} from "rxjs"
import {systemLayoutQuery, systemLayoutStore} from "store/system/layout/system.layout.store"
import {onEmit} from "utils/onEmit"

export const SubscribeSystemLayout = {
  isLoading: 'isLoading',
  systemLayouts: 'systemLayouts',
  active: 'activeSystemLayout',
}

function SystemLayoutService(subscribe: string[], caller: string) {

  const subscribed: Subscription[] = []

  const [isLoading, setIsLoading] = useState<boolean>()
  const [layouts, setLayouts] = useState<ApiSystemLayoutResult[]>([])
  const [active, setActive] = useState<ApiSystemLayoutResult>()

  useEffect(() => {
    if (!subscribe) throw Error(`Service.System.Layout: Define what you want to subscribe to`)
    if (!caller) throw Error("Service.System.Layout: Define where you are calling from")

    subscribe.map(s => {
      if (!Object.values(SubscribeSystemLayout).includes(s))
        throw new Error(`Service.System.Layout.${caller}: Can't subscribe to: ${s}`)
    })

    Logger(`Service.System.Layout.init.${caller}`, subscribe.join(', '))

    let isEffectStale = false

    if (undefined === systemLayoutStore.getValue().loading) {
      systemLayoutStore.setLoading(true)
      API.get(`/system/layout`).then(get => {
        if (isEffectStale) return
        systemLayoutStore.set(get.data)
        systemLayoutStore.setLoading(false)
      })
    }

    if (subscribe.includes(SubscribeSystemLayout.isLoading))
      subLoading()

    if (subscribe.includes(SubscribeSystemLayout.systemLayouts))
      subLayouts()

    if (subscribe.includes(SubscribeSystemLayout.active))
      subActive()

    return () => {
      Logger(`Service.System.Layout.unloading.${caller}`)
      isEffectStale = true
      subscribed.map(s => s.unsubscribe())
    }
  }, [])

  function setActiveSystemLayout(layout: ApiSystemLayoutResult | undefined) {
    Logger(`Service.System.Layout.${caller}`, 'setActiveSystemLayout', layout)

    const tab = layout?.tabs.find(t => t.order === 0)
    Logger(`Service.System.Layout.${caller}`, 'setActiveSystemLayout', 'tab', tab)

    applyTransaction(() => {
      systemLayoutStore.setActive(layout?.id ?? null)
      systemLayoutStore.ui.setActive(layout?.id ?? null)
      if (layout) {
        const uiLayout = systemLayoutQuery.ui.getEntity(layout.id)
        if (undefined === uiLayout?.activeTab) {
          systemLayoutStore.ui.update(layout.id, state => {
            state.activeTab = tab!.id
          })
        }
      }
    })

  }

  return {
    systemLayoutsLoading: isLoading,
    systemLayouts: layouts,
    systemLayoutActive: active,
    setActiveSystemLayout
  }

  function subLoading() {
    subscribed.push(onEmit(systemLayoutQuery.selectLoading(), newLoading => {
      setIsLoading(newLoading)
    }))
  }

  function subLayouts() {
    subscribed.push(onEmit(systemLayoutQuery.selectAll(), newAll => {
      setLayouts(newAll)
    }))
  }

  function subActive() {
    subscribed.push(onEmit(systemLayoutQuery.selectActive(), newActive => {
      Logger(`Service.System.Layout.push.${caller}.active`, newActive)
      // if (undefined === newActive)
      //   return
      setActive(newActive)
    }))
  }

}

export default SystemLayoutService
